module.exports = __webpack_public_path__ + "img/contact5.04128482.png";